import moment from 'moment';
import FormReport from "../FormList/FormReport";
import React, { useEffect, useRef, useState } from 'react'
import { Spinner, Table } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import { studyOtherSettingsServices } from '../../../../APIServices/studyOtherSettingsServices';
import { useParams } from 'react-router';

const FormDataEntryReport = ({
    formName,
    recordNumber,
    StudyMode,
    studyPermission,
    activeTabName,
    formRepeat,
    repeatNumber,
    totalDataEntry,
    repeatButtonLoader,
    repeatStudySubjectEventForm,
    saveButtonLoader,
    addNewStudySubjectDataEntry,
    setToggle4,
    formFields,
    totalOptionId,
    valueRanderFunction,
    handleNumberChange,
    handleCustomNumberChange,
    handleTextChange,
    handleCustomTextChange,
    handleDateChange,
    handleCustomDateChange,
    handleTimeChange,
    handleCustomTimeChange,
    handleTextareaChange,
    handleDropdownRadioChange,
    handleCustomDropdownRadioChange,
    handleRangeScoreChange,
    handleScaleChange,
    handleUploadChange,
    handleCheckboxChange,
    handleCustomCheckboxChange,
    convertTo24,
    getStudySubjectFormFieldQueryHistoryDataEntry,
    getStudySubjectFormFieldQueryNotificationDataEntry,
    getStudySubjectFormFreezeUnfreezeHistoryDataEntry,
    getStudySubjectFormFieldReviewHistoryDataEntry,
    getStudyDataEntryFieldUpdatedHistoryList,
    dataEntryFormReviewHistory,
    dataEntryFormReviewHistoryLoader,
    formId,
    setToggle6,
    getStudySubjectFormReviewHistoryDataEntry,
    version,
    editField,
    handleCheckboxEditFieldChange
}) => {
    const GeneratedDate = moment(new Date()).format("DD-MMM-YYYY | HH:mm:ss");
    let { studyId } = useParams();
    const [errorValidation, setErrorValidation] = useState(false)
    const [reportHeaders, setReportHeaders] = useState([]);
    const [reportFooters, setReportFooters] = useState([]);
    const [reportLogo, setReportLogo] = useState("");
    const componentRef = useRef();
    const getReportStudyMetadataData = async () => {
        let data = await studyOtherSettingsServices.getReportStudyMetadataData(studyId)
        let reportData = data?.data || []
        let headerData = reportData?.find(item => item.type === "header")?.headerData || []
        let footerData = reportData?.find(item => item.type === "footer")?.footerData || []
        let logoData = reportData?.find(item => item.type === "logo")
        setReportHeaders(headerData)
        setReportFooters(footerData)
        setReportLogo(logoData)
    }

    useEffect(() => {
        getReportStudyMetadataData();
    }, []);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `${formName} Report`,
    });
    return (
        <>
            <div className="border-bottom p-2 bg-light">
                <div className="hstack justify-content-between" style={{ height: 30 }}>
                    <h6 className="fw-bold mb-0">
                        <i className="fa-solid fa-file-prescription me-2"></i>
                        {formName} {recordNumber && `(${recordNumber})`}
                    </h6>
                    <div className="hstack gap-2">
                        {StudyMode === "DBP Mode" || studyPermission?.qcPrintReport || studyPermission?.livePrintReport || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly) &&
                            <button
                                onClick={handlePrint}
                                className={`updateProfile`}
                                title="Print Form"
                            >
                                <span>Print</span>
                            </button>
                        }
                        {(StudyMode === "DBP Mode" || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) && !(StudyMode?.startsWith("SDV")) && activeTabName?.viewType === "dataEntry" ?
                            <>
                                {formRepeat === "yes" && repeatNumber === 0 &&
                                    <button
                                        disabled={totalDataEntry?.length === 0 || repeatButtonLoader}
                                        onClick={repeatStudySubjectEventForm}
                                        className={`updateProfile`}
                                        title="Repeat Form"
                                    >
                                        <span>
                                            {repeatButtonLoader ? (
                                                <div className='hstack gap-2'>
                                                    <Spinner size="sm" /> Repeating...
                                                </div>
                                            ) : (
                                                "Repeat Form"
                                            )}
                                        </span>
                                    </button>
                                }
                                <button
                                    disabled={totalDataEntry?.length === 0 || errorValidation || saveButtonLoader}
                                    onClick={() => addNewStudySubjectDataEntry()}
                                    className={`updateProfile`}
                                    title="Save Data Entry"
                                >
                                    <span>
                                        {saveButtonLoader ? (
                                            <div className='hstack gap-2'>
                                                <Spinner size="sm" /> Saving...
                                            </div>
                                        ) : (
                                            "Save Data Entry"
                                        )}
                                    </span>
                                </button>
                            </>
                            : StudyMode?.startsWith("SDV") &&
                            <button
                                disabled={totalDataEntry?.length === 0}
                                onClick={() => setToggle4()}
                                className={`updateProfile`}
                                title="SDV All Field"
                            >
                                <span>SDV All Field</span>
                            </button>
                        }
                    </div>
                </div>
            </div>
            <div className="overflow-auto" style={{ height: "calc(100vh - 191px)" }}>
                <div ref={componentRef}>
                    <Table className="m-0">
                        <thead>
                            <div className="headPrint">
                                <div className="hstack justify-content-between py-3">
                                    <div>
                                        {reportHeaders?.length > 0 && reportHeaders?.map((item, index) => (
                                            <p key={index} className="m-0 fw-bold" style={{ fontSize: 12 }}>{item?.text}</p>
                                        ))}
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Form Name: {formName}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Form Version: V{version}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Site: {activeTabName?.siteName}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Subject: {activeTabName?.subjectName}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Event: {activeTabName?.eventName} {activeTabName?.timePointLabel && `(${activeTabName?.timePointLabel})`}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Generated On: {GeneratedDate}</p>
                                    </div>
                                    <img src={reportLogo?.logo || ""} alt="Company Logo" style={{ width: reportLogo?.width || 150, height: reportLogo?.height || 80 }} />
                                </div>
                            </div>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-0 p-0">
                                    <FormReport
                                        emptyDataEntry={totalDataEntry?.length === 0}
                                        formFields={formFields}
                                        totalOptionId={totalOptionId}
                                        setErrorValidation={setErrorValidation}
                                        valueRanderFunction={valueRanderFunction}
                                        handleNumberChange={handleNumberChange}
                                        handleCustomNumberChange={handleCustomNumberChange}
                                        handleTextChange={handleTextChange}
                                        handleCustomTextChange={handleCustomTextChange}
                                        handleDateChange={handleDateChange}
                                        handleCustomDateChange={handleCustomDateChange}
                                        handleTimeChange={handleTimeChange}
                                        handleCustomTimeChange={handleCustomTimeChange}
                                        handleTextareaChange={handleTextareaChange}
                                        handleDropdownRadioChange={handleDropdownRadioChange}
                                        handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
                                        handleRangeScoreChange={handleRangeScoreChange}
                                        handleScaleChange={handleScaleChange}
                                        handleUploadChange={handleUploadChange}
                                        handleCheckboxChange={handleCheckboxChange}
                                        handleCustomCheckboxChange={handleCustomCheckboxChange}
                                        convertTo24={convertTo24}
                                        mode={StudyMode}
                                        studyPermission={studyPermission}
                                        enableDataEntry={(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly) ? "" : activeTabName?.viewType === "dataEntry"}
                                        getStudySubjectFormFieldQueryHistoryDataEntry={getStudySubjectFormFieldQueryHistoryDataEntry}
                                        getStudySubjectFormFieldQueryNotificationDataEntry={getStudySubjectFormFieldQueryNotificationDataEntry}
                                        getStudySubjectFormFreezeUnfreezeHistoryDataEntry={getStudySubjectFormFreezeUnfreezeHistoryDataEntry}
                                        getStudySubjectFormFieldReviewHistoryDataEntry={getStudySubjectFormFieldReviewHistoryDataEntry}
                                        getStudyDataEntryFieldUpdatedHistoryList={getStudyDataEntryFieldUpdatedHistoryList}
                                        dataEntryFormReviewHistory={dataEntryFormReviewHistory}
                                        dataEntryFormReviewHistoryLoader={dataEntryFormReviewHistoryLoader}
                                        formId={formId}
                                        setToggle6={setToggle6}
                                        getStudySubjectFormReviewHistoryDataEntry={getStudySubjectFormReviewHistoryDataEntry}
                                        handleCheckboxEditFieldChange={handleCheckboxEditFieldChange}
                                        editField={editField}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        </>
    )
}

export default FormDataEntryReport
